const WD = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

// Event datetimes are stored as wall-clock local time (the time shown at the venue).
// Strip any timezone designator so they display the same for every viewer, regardless
// of the viewer's browser timezone — no accidental UTC-conversion shift.
export function parseEventDate(iso) {
  if (!iso) return new Date(NaN);
  const naive = String(iso).replace(/(?:Z|[+-]\d{2}:?\d{2})$/, "");
  return new Date(naive);
}

export function recurrenceLabel(ev) {
  if (!ev || !ev.is_recurring) return null;
  if (ev.recurrence === "monthly") return "Monthly";
  const d = parseEventDate(ev.start_datetime);
  return `Every ${WD[d.getDay()]}`;
}

function addMonthlyNth(d) {
  const wd = d.getDay();
  const nth = Math.floor((d.getDate() - 1) / 7); // 0-based week-of-month
  const first = new Date(d.getFullYear(), d.getMonth() + 1, 1, d.getHours(), d.getMinutes());
  const off = (wd - first.getDay() + 7) % 7;
  return new Date(first.getFullYear(), first.getMonth(), 1 + off + nth * 7, d.getHours(), d.getMinutes());
}

export function nextOccurrences(ev, count = 6) {
  if (!ev || !ev.is_recurring) return [];
  const out = [];
  let d = parseEventDate(ev.start_datetime);
  for (let i = 0; i < count; i++) {
    out.push(new Date(d));
    d = ev.recurrence === "monthly" ? addMonthlyNth(d) : new Date(d.getTime() + 7 * 86400000);
  }
  return out;
}
